import { takeLeading, call, put, select } from 'typed-redux-saga'
import { errorHandler, notifyMessageCreator, gridSlice } from 'Modules'
import { ResponseCatalog } from 'Models'
import {
	templateApi,
	TemplateModel,
	TemplateNS,
	templateSlice,
	templateSelectors,
} from 'Pages/admin'
import { FormNames } from 'Constants/FormNames'
import { Deserialize } from 'cerialize'

export function* getList(action: TemplateNS.GetList) {
	try {
		const { params, clear, callback } = action.payload
		yield* put(gridSlice.actions.setLoading(true))
		if (clear) {
			yield* put(templateSlice.actions.clearAll())
		}
		const res = yield* call(templateApi.getList, params)
		const logsResponse = new ResponseCatalog<TemplateModel>(res)
		logsResponse.entries = logsResponse.entries.map(
			(log): TemplateModel => Deserialize(log, TemplateModel)
		)
		if (!clear) {
			const oldLogs = yield* select(templateSelectors.getList)
			logsResponse.entries = [...oldLogs, ...logsResponse.entries]
		}
		yield* put(templateSlice.actions.setList(logsResponse))
		yield* put(templateSlice.actions.setParams(params))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

export function* updateOne(action: TemplateNS.UpdateOne) {
	try {
		const { id, data, callback } = action.payload
		yield* put(templateSlice.actions.setIsLoading(true))
		yield* call(templateApi.updateOne, id, data)
		const requestParams = yield* select(templateSelectors.getParams)
		const res = yield* call(templateApi.getList, requestParams)
		const calls = new ResponseCatalog<TemplateModel>(res)
		yield* put(templateSlice.actions.setList(calls))
		yield* call(notifyMessageCreator, 'common.template_update.success')
		callback?.()
	} catch (error) {
		const { errorCallback } = action.payload
		yield* call(errorHandler, error, FormNames.ADMIN.TEMPLATE)
		errorCallback?.(error.data?.errors)
	} finally {
		yield* put(templateSlice.actions.setIsLoading(false))
	}
}
export function* getOne(action: TemplateNS.GetOne) {
	try {
		const { id } = action.payload
		const res = yield* call(templateApi.getOne, id)
		yield* put(templateSlice.actions.setOne(res))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* templateSaga() {
	yield* takeLeading(templateSlice.actions.getList, getList)
	yield* takeLeading(templateSlice.actions.updateOne, updateOne)
	yield* takeLeading(templateSlice.actions.getOne, getOne)
}
